<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="filter_headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID" v-bind:class="{ 'warning-line': item.IsFragileGoods || item.IsCheck || item.OrderGuarantee}">
                <td>{{ item.TransactionCode }}</td>
                <td>{{ item.OrderID > 0 ? (item.PackageType == 0 ? 'MD' : 'KG') + item.OrderID : ''}}</td>
                <td>
                  {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                  <br v-if="item.IsFragileGoods" />
                  {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                  <br v-if="item.IsCheck" />
                  {{ item.OrderGuarantee ? 'Bảo hiểm' : '' }}
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.Weight"
                    large
                    lazy
                    persistent
                    @save="saveItem(item)"
                  >
                    <div>{{ item.Weight | currency('', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.Weight"
                        type="number"
                        step=".1"
                        label="Khối lượng (kg)"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeShip"
                    large
                    lazy
                    persistent
                    @save="saveItem(item)"
                  >
                    <div>{{ item.FeeShip | currency('', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeShip"
                        type="number"
                        step=".1"
                        label="Phí ship"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeFragileGoods"
                    large
                    lazy
                    persistent
                    @save="saveItem(item)"
                  >
                    <div>{{ item.FeeFragileGoods | currency('', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeFragileGoods"
                        type="number"
                        step=".1"
                        label="Phí gia cố"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeOther"
                    large
                    lazy
                    persistent
                    @save="saveItem(item)"
                  >
                    <div>{{ item.FeeOther | currency('', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeOther"
                        type="number"
                        step=".1"
                        label="Phí khác"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-if="item.BigPackageID > 0 && getBigPackage(item.BigPackageID) == ''">
                  {{item.PackageCode}}
                </td>
                <td v-if="item.BigPackageID == 0 || getBigPackage(item.BigPackageID) != ''">
                  <v-edit-dialog
                    :return-value.sync="item.BigPackageID"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'BigPackageID': item.BigPackageID})"
                  >
                    <div>{{ item.PackageCode }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="packages"
                        v-model="item.BigPackageID"
                        item-text="PackageCode"
                        item-value="ID"
                        v-on:change="item.PackageCode = getBigPackage(item.BigPackageID)"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>{{ item.StoreCNImportDate | display_date }}</td>
                <td>{{ item.PackDate | display_date }}</td>
                <td>{{ item.Username }}</td>
                <td class="truncate">
                  <v-edit-dialog :return-value.sync="item.StoreCNNote" large lazy persistent @save="saveItem({'ID': item.ID, 'StoreCNNote': item.StoreCNNote})">
                      <v-tooltip top right max-width="250">
                          <template v-slot:activator="{ on }">
                              <span v-on="on">{{ item.StoreCNNote }}</span>
                          </template>
                          <span>{{ item.StoreCNNote }}</span>
                      </v-tooltip>
                      <template v-slot:input>
                          <v-textarea v-model="item.StoreCNNote" label="Ghi chú" single-line autofocus></v-textarea>
                      </template>
                  </v-edit-dialog>
                </td>
                <td class="text-center">
                  <v-tooltip top>
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" v-if="(storeRole & 4)" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </template>
                      <span>Xóa mã vận đơn</span>
                  </v-tooltip>
                  
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <store-popup
        :dialogStoreManager="dialogStoreManager"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></store-popup>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import store from "@/components/popups/store";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
    "store-popup": store
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Mã đơn hàng",
          value: "OrderID",
          filterable: true,
          quickSearch: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cảnh báo",
          sortable: false,
          filterable: false,
        },
        {
          text: "Khối lượng (kg)",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí gia cố",
          value: "FeeFragileGoods",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí khác",
          value: "FeeOther",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Mã bao hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Ngày nhập kho",
          value: "StoreCNImportDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ngày đóng bao",
          value: "PackDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Ghi chú",
          value: "StoreCNNote",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "storemanager_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogStoreManager: false,
      dialogEditTranCode: false
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    storeRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2)});
    }
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.all.data,
      total_rows: state => state.orderTransaction.all.total,
      currentItem: state => state.orderTransaction.selected,
      loading: state => state.orderTransaction.loading,
      packages: state => state.bigPackage.inTQ,
      guarantees: state => {
        let tmp = [{name: 'Không sử dụng', value: 0}];
        if(state.feeGuarantee.all.data) {
        state.feeGuarantee.all.data.forEach(element => {
            tmp.push({name: element.PackageName, value: element.ID});
        });
        }
        return tmp;
      },
    }),
    storeRole() {
      return this.$store.state.authentication.role.StoreCN;
    },
    param() {
      let pr = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      pr.filter.push({
        column: "Status",
        value: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
        condition: "equal"
      });
      return pr;
    },    
    filter_headers() {
      let tmp = [...this.headers];
      tmp.push({
          text: "Đóng gỗ",
          value: "IsFragileGoods",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Kiểm hàng",
          value: "IsCheck",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Bảo hiểm",
          value: "OrderGuarantee",
          filterable: true,
          values: this.guarantees,
          dataType: configs.DATA_TYPE["Enum"]
        });
      return tmp;
    },
  },
  methods: {
    filter_data: function() {
      this.$store.dispatch("bigPackage/getListInTQ");
      this.$store.dispatch("orderTransaction/getList", this.param);
      this.$store.dispatch("feeGuarantee/getList");
    },
    gotoDetail: function(id) {
      let item = _.find(this.items, { ID: id });
      this.$store.commit("orderTransaction/setDetail", { data: item });
      this.dialogEditTranCode = true;
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      if(this.storeRole & 2) {
        this.$store.commit("orderTransaction/setDetail", {
          data: {
            ID: 0,
            TransactionCode: "",
            FeeShip: 0
          }
        });
        this.dialogStoreManager = true;
      }
      else {
        sendErrorNotice("Bạn không có quyền thêm mới!");
      }
    },
    saveItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          ...item,
          'TransactionView': 'store_tq'
        },
        id: item.ID,
        param: this.param
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogEditTranCode = false;
    },
    closePopup() {
      this.dialogStoreManager = false;
      this.filter_data();
    },
    getBigPackage(bigPackageID) {
      const item = _.find(this.packages, {ID: bigPackageID});
      return item ? item.PackageCode : '';
    }
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2)});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          'RequestAction': 'DEL',
          'TransactionView': 'store_cn'
        },
        'id': id,
        param: this.param
      });
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
<style scoped>
.warning-line {
  background-color: rgba(250, 117, 117, 0.726);
}
</style>
